import { useParams } from 'react-router';
import { useSetBreadcrumbEffect } from '../../contexts/BreadcrumbContext';
import { TeamFarmsQuery } from '../../views/TeamFarmsView';
import NewFarm from './NewFarm';

const NewTeamFarm = () => {
  const { teamId } = useParams();
  const breadcrumbs = [
    { display: 'Projects', url: ':rootUrl/farms' },
    { display: 'New Project' },
  ];
  useSetBreadcrumbEffect(breadcrumbs, []);

  return <NewFarm teamId={teamId} refetchQuery={TeamFarmsQuery} />;
};

export default NewTeamFarm;
